import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

export interface TravelVipSuccessModalResult {
  source: 'cta' | 'timeout' | 'destroyed';
}

@Component({
  selector: 'app-travel-vip-success-modal',
  templateUrl: './travel-vip-success-modal.component.html',
  styleUrls: ['./travel-vip-success-modal.component.scss'],
})
export class TravelVipSuccessModalComponent implements OnInit, OnDestroy {
  @Input() appLogo?: string;
  @Input() autoDismissMs = 4000;

  successImage = 'https://img.travelx.ai/bfl/login_successful.png';

  private autoDismissTimer?: ReturnType<typeof setTimeout>;
  private dismissed = false;

  constructor(
    private modalController: ModalController,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.autoDismissTimer = setTimeout(
      () => this.dismiss('timeout'),
      this.autoDismissMs
    );
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  onAccessBenefits(): void {
    this.analyticsService.trackEvent('button_clicked', {
      button: 'jsp-success-modal-access-benefits',
    });
    this.dismiss('cta');
  }

  private dismiss(source: TravelVipSuccessModalResult['source']): void {
    if (this.dismissed) {
      return;
    }
    this.dismissed = true;
    this.clearTimer();
    this.modalController.dismiss({ source } as TravelVipSuccessModalResult);
  }

  private clearTimer(): void {
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer);
      this.autoDismissTimer = undefined;
    }
  }
}
